// HelpMenu — question-mark control in the persistent top nav.
// Opens a small menu with the "Strata Playbook" link. Clicking it runs the
// backend SSO handoff (POST /playbook/access-ticket, via useOpenPlaybook) and
// opens the returned URL in a new tab. The destination + ticket are
// composed and signed server-side; nothing is hardcoded here.

import { HelpCircle, BookOpen, Loader2 } from 'lucide-react';
import {
  DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem,
} from '@/components/ui/dropdown-menu';
import { useOpenPlaybook } from '@/hooks/useOpenPlaybook';

export function HelpMenu() {
  const { open: openPlaybook, loading } = useOpenPlaybook();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          data-testid="help-menu-trigger"
          aria-label="Help"
          title="Help"
          className="flex items-center justify-center w-7 h-7 rounded-md transition-colors hover:bg-[color:var(--strata-canvas-soft)]"
          style={{ color: 'var(--strata-text-muted)' }}
        >
          {loading
            ? <Loader2 className="w-4 h-4 animate-spin" />
            : <HelpCircle className="w-4 h-4" />}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-64" data-testid="help-menu-content">
        <DropdownMenuItem
          data-testid="help-menu-playbook"
          disabled={loading}
          onSelect={(e) => { e.preventDefault(); openPlaybook(); }}
          className="flex items-start gap-2.5 py-2 cursor-pointer"
        >
          <span className="inline-flex h-7 w-7 items-center justify-center rounded-lg bg-[#4575A8]/10 flex-shrink-0 mt-0.5">
            {loading
              ? <Loader2 className="w-4 h-4 text-[#4575A8] animate-spin" />
              : <BookOpen className="w-4 h-4 text-[#4575A8]" />}
          </span>
          <span className="min-w-0">
            <span className="block text-sm font-medium text-foreground">Strata Playbook</span>
            <span className="block text-xs text-[#5C6370]">Guides and instructions for using Strata</span>
          </span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
